/* Ability Warehouse — Product Match: describe what's hard, or narrow by where / what's hard / budget / who. Uses the shared product index (CWIndex). */
(function () {
  'use strict';
  var root = document.querySelector('[data-product-match]');
  if (!root || !window.CWIndex) return;
  var X = window.CWIndex;
  var $ = function (s) { return root.querySelector(s); };
  var full = root.dataset.layout === 'full';
  var finderUrl = root.dataset.finderUrl || '/pages/product-finder';
  var cfg = window.CW || {};

  /* ---------- helpers over an index item ---------- */
  function tag(it, t) { return (it.tg || []).indexOf(t) > -1; }
  function uf(it, word) { return String(it.uf || '').toLowerCase().indexOf(word) > -1; }
  function text(it) { return (it.t + ' ' + (it.tg || []).join(' ').replace(/-/g, ' ') + ' ' + (it.uf || '')).toLowerCase(); }
  function re(r) { return function (it) { return r.test(text(it)); }; }
  function any() { var fns = Array.prototype.slice.call(arguments); return function (it) { for (var i = 0; i < fns.length; i++) if (fns[i](it)) return true; return false; }; }
  function dollars(it) { return (it.per || it.p) / 100; }

  var ICON = {
    bath: '<path d="M5 13h22v3a7 7 0 0 1-7 7h-8a7 7 0 0 1-7-7z"/><path d="M8 13V7a3 3 0 0 1 6 0"/><path d="M10 23l-1 3M22 23l1 3"/>',
    toilet: '<path d="M9 5h10v9H9z"/><path d="M6 14h20a7 7 0 0 1-7 7h-6a7 7 0 0 1-7-7z"/><path d="M11 21l-1 5M21 21l1 5"/>',
    bed: '<path d="M4 20V9h24v11"/><path d="M4 15h24"/><path d="M8 9V6h16v3"/><path d="M4 20v4M28 20v4"/>',
    walk: '<circle cx="18" cy="6" r="2.5"/><path d="M15 12l3-2 4 3 3 4M12 27l4-9 3 2 2 7"/><path d="M8 14v13"/>',
    home: '<path d="M6 26V12l10-7 10 7v14"/><path d="M13 26v-8h6v8"/>',
    stand: '<circle cx="16" cy="6" r="2.5"/><path d="M12 12h8l-2 8h-4z"/><path d="M14 20l-2 7M18 20l2 7"/><path d="M6 14l4-1M26 14l-4-1"/>',
    shower: '<path d="M8 6h8a6 6 0 0 1 6 6v2"/><path d="M18 14h8"/><path d="M19 18v2M22 18v3M25 18v2M16 18v3M13 18v2"/><path d="M6 26h20"/>',
    transfer: '<circle cx="10" cy="7" r="2.5"/><path d="M6 14h8v8H6z"/><path d="M18 11h8M22 7l4 4-4 4"/><path d="M20 26h8"/>',
    reach: '<circle cx="10" cy="6" r="2.5"/><path d="M8 11h4l3 9h-5z"/><path d="M12 11l10 2"/><path d="M22 13l4-2"/><path d="M8 27l2-7M14 27l-1-7"/>',
    cont: '<path d="M16 5c-4 6-7 9-7 14a7 7 0 0 0 14 0c0-5-3-8-7-14z"/>',
    pain: '<path d="M16 27s-10-6-10-13a5.5 5.5 0 0 1 10-3 5.5 5.5 0 0 1 10 3c0 7-10 13-10 13z"/><path d="M10 15h3l2-4 2 8 2-4h3"/>',
    alert: '<path d="M16 4l12 22H4z"/><path d="M16 12v6"/><circle cx="16" cy="22" r="1.2" fill="currentColor"/>',
    me: '<circle cx="16" cy="9" r="5"/><path d="M6 27a10 10 0 0 1 20 0"/>',
    carer: '<circle cx="11" cy="9" r="4"/><circle cx="22" cy="11" r="3"/><path d="M4 26a7 7 0 0 1 14 0"/><path d="M17 26a5 5 0 0 1 10 0"/>',
    client: '<rect x="5" y="8" width="22" height="18" rx="2"/><path d="M11 8V5h10v3"/><path d="M9 15h14M9 20h8"/>'
  };

  /* ---------- the steps ---------- */
  var steps = [
    {
      key: 'where', q: 'Where is it needed?', hint: 'Pick one', single: true, kind: 'icon',
      opts: [
        { v: 'bathroom', l: 'Bathroom', ic: 'bath', test: any(function (it) { return tag(it, 'need-bathroom') || uf(it, 'bathroom') || uf(it, 'shower') || uf(it, 'bath'); }, re(/\b(shower|bath|bathroom)\b/)),
          tip: 'Wet areas: look for rubber feet, a weight rating above the user\'s weight, and a seat height close to their lower-leg length. Anything fixed to a tiled wall needs the right anchors.' },
        { v: 'toilet', l: 'Toilet', ic: 'toilet', test: any(function (it) { return tag(it, 'need-toilet') || uf(it, 'toilet'); }, re(/\b(toilet|commode|toileting)\b/)),
          tip: 'Measure the gap each side of the toilet before choosing a frame, and check the seat height the user can stand from. Raised seats come in 5, 10 and 15 cm.' },
        { v: 'bedroom', l: 'Bedroom', ic: 'bed', test: any(function (it) { return tag(it, 'need-bedroom') || uf(it, 'bed'); }, re(/\b(bed|bedroom|mattress|overbed|pillow)\b/)),
          tip: 'Bed rails and sticks need a firm mattress base; check the bed type. Mattress protectors come in single, double and king single.' },
        { v: 'walking', l: 'Getting around', ic: 'walk', test: any(function (it) { return tag(it, 'need-walking') || tag(it, 'need-wheelchairs') || tag(it, 'dept-mobility'); }, re(/\b(walk|rollator|wheelchair|scooter|cane|crutch|ramp)/)),
          tip: 'Check the narrowest doorway the walker or chair must pass, and the user\'s height for handle height. Outdoor use needs bigger wheels.' },
        { v: 'home', l: 'Around the home', ic: 'home', test: any(function (it) { return tag(it, 'need-daily-living') || tag(it, 'need-smart-home') || tag(it, 'dept-living-aids') || tag(it, 'dept-smart-home'); }, re(/\b(kitchen|dressing|reacher|household|smart|sensor|doorbell|garden)\b/)),
          tip: 'Daily-living aids are mostly low-cost AT — usually no quote needed for NDIS. Smart-home devices need Wi-Fi and a phone or tablet to set up.' }
      ]
    },
    {
      key: 'what', q: 'What\'s hard?', hint: 'Pick any', kind: 'icon',
      opts: [
        { v: 'standing', l: 'Standing up', ic: 'stand', test: any(function (it) { return tag(it, 'need-toilet') || uf(it, 'toilet'); }, re(/\b(frame|raised|riser|lift chair|recliner|rail|stand|grab)\b/)),
          tip: 'Standing aids work best when the hands push down, not pull: a toilet frame or lift chair beats a grab rail alone.' },
        { v: 'showering', l: 'Showering', ic: 'shower', test: any(function (it) { return uf(it, 'shower'); }, re(/\b(shower|bath board|bath seat|transfer bench|long handled sponge)\b/)),
          tip: 'A shower stool or chair with a back lets the person sit for the whole shower; a bath board bridges the tub. Non-slip mats help everyone.' },
        { v: 'walking', l: 'Walking', ic: 'walk', test: any(function (it) { return tag(it, 'need-walking'); }, re(/\b(walking|walker|rollator|cane|stick|crutch|frame)\b/)),
          tip: 'Sticks for a light steady, frames for more weight-bearing, rollators for distance and a seat to rest on.' },
        { v: 'transferring', l: 'Transferring', ic: 'transfer', test: re(/\b(transfer|slide|sling|hoist|turntable|belt|lift|board)\b/),
          tip: 'Transfer boards and belts suit someone who can bear some weight; hoists and slings are for assisted transfers and should be set up by an OT.' },
        { v: 'reaching', l: 'Reaching', ic: 'reach', test: any(function (it) { return tag(it, 'need-daily-living'); }, re(/\b(reacher|reaching|long handled|sock|dressing|shoe horn|pick ?up)\b/)),
          tip: 'Long-handled reachers, sock aids and shoe horns stop bending; a 60–80 cm reacher suits most people.' },
        { v: 'continence', l: 'Continence', ic: 'cont', test: any(function (it) { return tag(it, 'need-incontinence') || tag(it, 'dept-incontinence'); }, re(/\b(incontinence|pads?|pants|nappies|briefs|protector|urinal|catheter)\b/)),
          tip: 'Pick absorbency by day/night use and the person\'s size. Opened hygiene products cannot be returned, so start with a small pack.' },
        { v: 'pain', l: 'Pain / support', ic: 'pain', test: any(function (it) { return tag(it, 'need-braces') || tag(it, 'dept-braces-support'); }, re(/\b(brace|support|splint|tens|heat|compression|cushion)\b/)),
          tip: 'Braces are sized by circumference — measure before you order. For a new injury, see a GP or physio first.' },
        { v: 'safety', l: 'Safety alerts', ic: 'alert', test: any(function (it) { return tag(it, 'need-smart-home') || tag(it, 'dept-smart-home'); }, re(/\b(alarm|alert|sensor|fall|pendant|doorbell|monitor|camera|smart)\b/)),
          tip: 'Fall and door sensors need a phone or Wi-Fi hub to send alerts; pendant alarms work on their own. Ask who will get the alert at 3 am.' }
      ]
    },
    { key: 'budget', q: 'Budget?', hint: 'Drag to set a range', kind: 'range' },
    {
      key: 'who', q: 'Who is it for?', hint: 'Pick one', single: true, kind: 'icon',
      opts: [
        { v: 'me', l: 'Myself', ic: 'me', test: function () { return true; },
          tip: 'Buying for yourself: an NDIS plan (self or plan managed), DVA card or Home Care Package can usually fund this — keep our invoice.' },
        { v: 'carer', l: 'Someone I care for', ic: 'carer', test: function () { return true; },
          tip: 'Buying for a family member: order in your name and add their name in the order notes so the invoice suits their plan manager.' },
        { v: 'client', l: 'A client / participant', ic: 'client', test: function () { return true; },
          tip: 'Ordering for a participant? Provider accounts are coming soon — call us and we\'ll place the order and send a claim-ready invoice.' }
      ]
    }
  ];
  if (!full) steps = steps.slice(0, 2);
  var byKey = {};
  steps.forEach(function (s) { byKey[s.key] = s; });

  /* ---------- state ---------- */
  var state = { sel: {}, min: 0, max: Infinity, q: '' };
  steps.forEach(function (s) { if (s.opts) state.sel[s.key] = []; });
  var items = [], results = [], sorted = [], shown = 0, MAXP = 500, sort = 'match', pillSync = null, rangeTimer;

  /* words in a typed request → choices */
  var PHRASES = [
    ['where', 'toilet', /\b(toilet|loo|commode|toileting)\b/],
    ['where', 'bathroom', /\b(shower|bath|bathroom|ensuite|wet area)\b/],
    ['where', 'bedroom', /\b(bed|bedroom|night|mattress)\b/],
    ['where', 'walking', /\b(walk|walker|walking|rollator|wheelchair|scooter|shops|outside|outdoors|frame|cane|stick)\b/],
    ['where', 'home', /\b(kitchen|cooking|dressing|garden|house|home|reach|door|alarm|sensor)\b/],
    ['what', 'standing', /\b(get up|getting up|stand|standing|rise|rising|off the|out of the chair|lift)\b/],
    ['what', 'showering', /\b(shower|showering|bath|bathing|wash)\b/],
    ['what', 'walking', /\b(walk|walking|unsteady|wobbly|balance|steps|far|distance|shops)\b/],
    ['what', 'transferring', /\b(transfer|transferring|move from|into bed|out of bed|into the car|slide)\b/],
    ['what', 'reaching', /\b(reach|reaching|bend|bending|floor|socks|shoes|dress|dressing|pick up)\b/],
    ['what', 'continence', /\b(continence|incontinence|leak|leaks|pads|nappies|wet the bed|bladder)\b/],
    ['what', 'pain', /\b(pain|sore|ache|brace|support|knee|back|wrist|ankle|arthritis|swelling)\b/],
    ['what', 'safety', /\b(fall|falls|fell|alarm|alert|safe|safety|wander|sensor|doorbell|dementia)\b/],
    ['who', 'carer', /\b(mum|dad|mother|father|nan|nanna|pop|grandma|grandpa|husband|wife|partner|son|daughter|my (friend|brother|sister))\b/],
    ['who', 'client', /\b(client|participant|resident|patient)\b/],
    ['who', 'me', /\b(i can'?t|i cannot|myself|for me|my own)\b/]
  ];

  /* ---------- matching ---------- */
  function stepPasses(it, step) {
    var sel = state.sel[step.key];
    if (!sel || !sel.length) return true;
    for (var i = 0; i < step.opts.length; i++) if (sel.indexOf(step.opts[i].v) > -1 && step.opts[i].test(it)) return true;
    return false;
  }
  function passes(it, skipKey) {
    for (var i = 0; i < steps.length; i++) {
      var s = steps[i];
      if (s.opts && s.key !== skipKey && !stepPasses(it, s)) return false;
    }
    if (skipKey === 'budget') return true;
    var d = dollars(it);
    return d >= state.min && d <= state.max;
  }
  function wordsPass(it) { return !state.q || X.search([it], state.q).length > 0; }
  function anyChosen() { return !!(state.q || state.min > 0 || state.max < Infinity || steps.some(function (s) { return s.opts && state.sel[s.key].length; })); }

  /* typed request → choices + leftover words */
  function understand(raw) {
    var t = ' ' + raw.toLowerCase().replace(/×/g, 'x') + ' ';
    steps.forEach(function (s) { if (s.opts) state.sel[s.key] = []; });
    state.min = 0; state.max = Infinity;
    var picked = [];
    var under = t.match(/(?:under|below|less than|max|up to)\s*\$?\s*(\d+)/);
    var over = t.match(/(?:over|above|more than|from|min)\s*\$?\s*(\d+)/);
    if (under) { state.max = +under[1]; t = t.replace(under[0], ' '); picked.push('under $' + under[1]); }
    if (over) { state.min = +over[1]; t = t.replace(over[0], ' '); picked.push('over $' + over[1]); }
    var rental = /\b(rent|rental|renting|landlord|strata|unit)\b/.test(t);
    PHRASES.forEach(function (p) {
      var step = byKey[p[0]];
      if (!step || !t.match(p[2])) return;
      if (step.single && state.sel[p[0]].length) return;
      if (state.sel[p[0]].indexOf(p[1]) < 0) state.sel[p[0]].push(p[1]);
      var o = step.opts.filter(function (x) { return x.v === p[1]; })[0];
      if (o && picked.indexOf(o.l) < 0) picked.push(o.l);
    });
    /* leftover words that name a product go to the text search; chatter is dropped */
    var left = t.replace(/\b(mum|dad|mother|father|nan|nanna|pop|grandma|grandpa|husband|wife|partner|son|daughter|my|i|me|can'?t|cannot|can|get|up|off|the|a|an|and|in|on|for|to|of|is|are|with|has|have|needs?|wants?|help|helps|please|something|anything|unit|rental|rent|renting|landlord|home|house|at|from|into|out|very|really|bit|some|shops|floor|toilet|shower|bath|bathroom|bed|bedroom|unsteady|reach)\b/g, ' ')
      .replace(/[^\w\s-]/g, ' ').replace(/\s+/g, ' ').trim();
    state.q = left;
    var nothing = '';
    if (left && !items.some(function (it) { return passes(it) && wordsPass(it); })) { nothing = left; state.q = ''; }
    var u = $('[data-tm-understood]');
    if (u) {
      u.hidden = !picked.length && !state.q && !nothing && !rental;
      u.innerHTML = (picked.length ? 'We picked: ' + picked.map(function (x) { return '<b>' + X.esc(x) + '</b>'; }).join(' · ') : '') +
        (state.q ? (picked.length ? ' · ' : '') + 'matching “' + X.esc(state.q) + '”' : '') +
        (nothing ? (picked.length ? ' · ' : '') + 'nothing mentions “' + X.esc(nothing) + '”, so here are the closest matches' : '') +
        (rental ? ' · <b>Renting:</b> we\'ve noted it — see the tip on fixing without drilling' : '');
    }
    state.rental = rental;
  }

  /* ---------- rendering ---------- */
  function icon(name) { return '<svg viewBox="0 0 32 32" aria-hidden="true">' + (ICON[name] || '') + '</svg>'; }
  function stepHTML(step, i) {
    var sel = state.sel[step.key] || [];
    var done = step.kind === 'range' ? state.min > 0 || state.max < Infinity : sel.length > 0;
    var h = '<li class="tm__step' + (done ? ' is-done' : '') + '" data-step="' + step.key + '"><div class="tm__step-head"><span class="tm__num">' + (done ? '✓' : i + 1) + '</span><h3 class="tm__q">' + step.q + '</h3><span class="tm__hint">' + step.hint + '</span>' +
      (done ? '<button type="button" class="tm__clear" data-clear="' + step.key + '">Clear</button>' : '') + '</div>';
    if (step.kind === 'range') {
      var lo = state.min, hi = state.max === Infinity ? MAXP : state.max;
      h += '<div class="tm__range" data-range><div class="tm__range-track"><span class="tm__range-fill" data-fill></span></div>' +
        '<input type="range" min="0" max="' + MAXP + '" step="5" value="' + lo + '" data-lo aria-label="Minimum price">' +
        '<input type="range" min="0" max="' + MAXP + '" step="5" value="' + hi + '" data-hi aria-label="Maximum price">' +
        '<div class="tm__range-vals"><b data-lo-v>$' + lo + '</b><span>to</span><b data-hi-v>' + (state.max === Infinity ? '$' + MAXP + '+' : '$' + hi) + '</b><span>each</span></div><div class="tm__quick">' +
        [['Any price', 0, Infinity], ['Under $50', 0, 50], ['$50 – $200', 50, 200], ['$200 – $500', 200, 500], ['$500+', 500, Infinity]].map(function (q) {
          return '<button type="button" class="tm__chip' + (state.min === q[1] && state.max === q[2] ? ' is-on' : '') + '" data-quick="' + q[1] + ',' + (q[2] === Infinity ? '' : q[2]) + '">' + q[0] + '</button>';
        }).join('') + '</div></div>';
      return h + '</li>';
    }
    var pool = items.filter(function (it) { return passes(it, step.key) && wordsPass(it); });
    h += '<div class="tm__opts tm__opts--' + step.kind + '">';
    step.opts.forEach(function (o) {
      var n = 0;
      for (var k = 0; k < pool.length; k++) if (o.test(pool[k])) n++;
      var on = sel.indexOf(o.v) > -1;
      h += '<button type="button" class="tm__opt' + (on ? ' is-on' : '') + (n ? '' : ' is-zero') + '" aria-pressed="' + on + '" data-k="' + step.key + '" data-v="' + o.v + '"' + (n || on ? '' : ' disabled') + '>' +
        '<span class="tm__vis tm__vis--icon">' + icon(o.ic) + '</span><span class="tm__opt-l">' + o.l + (o.sub ? '<small>' + o.sub + '</small>' : '') + '</span><span class="tm__count">' + n + '</span></button>';
    });
    return h + '</div></li>';
  }
  function fillRange() {
    var r = root.querySelector('[data-range]');
    if (!r) return;
    var lo = +r.querySelector('[data-lo]').value, hi = +r.querySelector('[data-hi]').value, f = r.querySelector('[data-fill]');
    f.style.left = (lo / MAXP) * 100 + '%'; f.style.right = 100 - (hi / MAXP) * 100 + '%';
  }
  function picksHTML(list) {
    if (!list.length) return '';
    var seen = {}, out = [];
    function add(it, badge) { if (it && !seen[it.i]) { seen[it.i] = 1; out.push({ it: it, b: badge }); } }
    var live = list.filter(function (it) { return it.a; });
    var pool = live.length ? live : list;
    add(pool.slice().sort(function (a, b) { return a.per - b.per; })[0], 'Best price');
    add(pool.slice().sort(function (a, b) { return (b.r - b.p) - (a.r - a.p); })[0], 'Biggest saving');
    add(pool.filter(function (it) { return /^yes/i.test(it.nd || ''); })[0], 'NDIS claimable');
    add(pool.slice().sort(function (a, b) { return b.d - a.d; })[0], 'Newest');
    pool.forEach(function (it) { if (out.length < 5) add(it, ''); });
    return out.map(function (o) {
      var it = o.it;
      return '<a class="tm__pick" href="' + it.url + '">' + (o.b ? '<span class="tm__badge tm__badge--' + o.b.toLowerCase().replace(/\s+/g, '-') + '">' + o.b + '</span>' : '') +
        '<span class="tm__pick-img">' + (it.im ? '<img src="' + X.img(it.im, 360) + '" alt="" loading="lazy" width="360" height="360">' : '') + '</span>' +
        '<span class="tm__pick-meta">' + X.esc([it.br, it.wr].filter(Boolean).join(' · ')) + '</span><span class="tm__pick-t">' + X.esc(it.t) + '</span>' +
        '<span class="tm__pick-p"><b>' + X.money(it.per) + '</b>' + (it.r > it.p ? ' <s>' + X.money(it.r) + '</s>' : '') + '</span></a>';
    }).join('');
  }
  function more() {
    var grid = $('[data-tm-grid]');
    if (!grid || shown >= sorted.length) return;
    var h = '';
    sorted.slice(shown, shown + 24).forEach(function (it) { h += X.card(it); });
    grid.insertAdjacentHTML('beforeend', h);
    shown = Math.min(sorted.length, shown + 24);
    var m = $('[data-tm-more]');
    if (m) m.hidden = shown >= sorted.length;
  }
  function query() {
    var u = new URLSearchParams();
    steps.forEach(function (s) { if (s.opts && state.sel[s.key].length) u.set(s.key, state.sel[s.key].join(',')); });
    if (state.min > 0) u.set('min', state.min);
    if (state.max < Infinity) u.set('max', state.max);
    if (state.q) u.set('q', state.q);
    return u.toString();
  }
  function tips() {
    var list = [];
    steps.forEach(function (s) { (s.opts || []).forEach(function (o) { if (o.tip && state.sel[s.key].indexOf(o.v) > -1) list.push({ h: o.l, t: o.tip }); }); });
    if (state.rental) list.unshift({ h: 'Renting', t: 'Anything screwed to a wall needs the landlord\'s OK in writing. Free-standing and clamp-on options — over-toilet frames, bath boards, shower stools — need no drilling at all.' });
    var el = $('[data-tm-tips]');
    el.innerHTML = list.length ? list.map(function (x) { return '<div class="tm__tip"><p class="tm__tip-h">' + X.esc(x.h) + '</p><p>' + x.t + '</p></div>'; }).join('')
      : '<p class="tm__tip tm__tip--intro">Tailored notes appear here as you choose — what suits the person, what to measure, and what to ask us.</p>';
  }

  function apply() {
    results = items.filter(function (it) { return passes(it) && wordsPass(it); });
    sorted = results.slice();
    if (sort === 'price-asc') sorted.sort(function (a, b) { return a.per - b.per; });
    else if (sort === 'price-desc') sorted.sort(function (a, b) { return b.per - a.per; });
    else if (sort === 'newest') sorted.sort(function (a, b) { return b.d - a.d; });
    else sorted.sort(function (a, b) { return b.a - a.a; });
    var n = sorted.length, chosen = anyChosen();
    $('[data-tm-res-kicker]').textContent = chosen ? 'Your shortlist is ready' : 'Results';
    $('[data-tm-res-title]').innerHTML = chosen ? 'You narrowed <b>' + items.length + '</b> products down to <b class="tm__hl">' + n + '</b>.'
      : '<b class="tm__hl">' + items.length + '</b> products — narrow by where, what\'s hard, budget or who to begin.';
    var tags = [];
    steps.forEach(function (s) { (s.opts || []).forEach(function (o) { if (state.sel[s.key].indexOf(o.v) > -1) tags.push('<button type="button" class="tm__tag" data-k="' + s.key + '" data-v="' + o.v + '"><small>' + s.key + '</small>' + o.l + ' ✕</button>'); }); });
    if (state.min > 0 || state.max < Infinity) tags.push('<button type="button" class="tm__tag" data-clear="budget"><small>budget</small>$' + state.min + ' – ' + (state.max === Infinity ? 'any' : '$' + state.max) + ' ✕</button>');
    if (state.q) tags.push('<button type="button" class="tm__tag" data-clear="q"><small>words</small>“' + X.esc(state.q) + '” ✕</button>');
    $('[data-tm-chosen]').innerHTML = tags.join('');
    $('[data-tm-picks]').innerHTML = chosen || !full ? picksHTML(sorted) : picksHTML(sorted.slice(0, 40));
    var empty = $('[data-tm-empty]');
    if (empty) empty.hidden = n > 0;
    var go = $('[data-tm-go]');
    if (go) { var qs = query(); go.href = finderUrl + (qs ? '?' + qs : ''); go.textContent = 'See all ' + n + ' matching products →'; go.hidden = !n; }
    if (full) {
      $('[data-tm-grid]').innerHTML = ''; shown = 0; more();
      var gh = $('[data-tm-gridhead]'); if (gh) gh.hidden = !n;
      var qs2 = query();
      history.replaceState(null, '', location.pathname + (qs2 ? '?' + qs2 : '') + location.hash);
    }
    var pn = $('[data-tm-pill-n]');
    if (pn) { pn.textContent = n; if (pillSync) pillSync(); }
    $('[data-tm-steps]').innerHTML = steps.map(stepHTML).join('');
    fillRange();
    tips();
  }
  function scrollToResults() {
    var top = $('[data-tm-results]').getBoundingClientRect().top + window.scrollY - (parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-h'), 10) || 0) - 12;
    window.scrollTo({ top: top, behavior: 'smooth' });
  }

  /* ---------- events ---------- */
  root.addEventListener('input', function (e) {
    var el = e.target;
    if (!el.matches('[data-lo],[data-hi]')) return;
    var r = el.closest('[data-range]'), lo = r.querySelector('[data-lo]'), hi = r.querySelector('[data-hi]');
    if (+lo.value > +hi.value - 5) { if (el === lo) lo.value = +hi.value - 5; else hi.value = +lo.value + 5; }
    r.querySelector('[data-lo-v]').textContent = '$' + lo.value;
    r.querySelector('[data-hi-v]').textContent = +hi.value >= MAXP ? '$' + MAXP + '+' : '$' + hi.value;
    fillRange();
    clearTimeout(rangeTimer);
    rangeTimer = setTimeout(function () {
      state.min = +lo.value; state.max = +hi.value >= MAXP ? Infinity : +hi.value;
      var which = document.activeElement === lo ? 'lo' : document.activeElement === hi ? 'hi' : null;
      apply();
      if (which) { var f = root.querySelector('[data-' + which + ']'); if (f) f.focus(); }
    }, 250);
  });
  root.addEventListener('click', function (e) {
    var b = e.target.closest('button');
    if (!b || !root.contains(b)) return;
    if (b.matches('.tm__opt, .tm__tag[data-k]')) {
      var k = b.dataset.k, v = b.dataset.v, step = byKey[k], sel = state.sel[k], i = sel.indexOf(v);
      if (i > -1) sel.splice(i, 1); else if (step.single) state.sel[k] = [v]; else sel.push(v);
      apply();
      if (!full && k === 'where' && state.sel[k].length) {
        var next = root.querySelector('[data-step="what"]');
        if (next && next.getBoundingClientRect().top > window.innerHeight * 0.7) next.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return;
    }
    if (b.hasAttribute('data-clear')) {
      var c = b.dataset.clear;
      if (c === 'budget') { state.min = 0; state.max = Infinity; }
      else if (c === 'q') { state.q = ''; var qi = $('[data-tm-q]'); if (qi) qi.value = ''; var u = $('[data-tm-understood]'); if (u) u.hidden = true; }
      else state.sel[c] = [];
      apply(); return;
    }
    if (b.hasAttribute('data-quick')) { var p = b.dataset.quick.split(','); state.min = +p[0]; state.max = p[1] === '' ? Infinity : +p[1]; apply(); return; }
    if (b.hasAttribute('data-tm-clear')) {
      steps.forEach(function (s) { if (s.opts) state.sel[s.key] = []; });
      state.min = 0; state.max = Infinity; state.q = ''; state.rental = false;
      var q2 = $('[data-tm-q]'); if (q2) q2.value = '';
      apply(); return;
    }
    if (b.hasAttribute('data-tm-try')) { var inp = $('[data-tm-q]'); inp.value = b.textContent; understand(inp.value); apply(); scrollToResults(); return; }
    if (b.hasAttribute('data-tm-loadmore')) more();
  });
  root.addEventListener('change', function (e) { if (e.target.matches('[data-tm-sort]')) { sort = e.target.value; apply(); } });
  var ask = $('[data-tm-ask]');
  if (ask) ask.addEventListener('submit', function (e) { e.preventDefault(); understand($('[data-tm-q]').value); apply(); scrollToResults(); });

  /* floating "N products — View" pill between the board and the results */
  var pill = $('[data-tm-pill]');
  if (pill && 'IntersectionObserver' in window) {
    var boardIn = false, resIn = false;
    pillSync = function () { pill.hidden = !(boardIn && !resIn && anyChosen()); };
    new IntersectionObserver(function (en) { boardIn = en[0].isIntersecting; pillSync(); }, { threshold: 0.05 }).observe($('.tm__board') || root);
    new IntersectionObserver(function (en) { resIn = en[0].isIntersecting; pillSync(); }, { threshold: 0.05 }).observe($('[data-tm-results]'));
    pill.addEventListener('click', function (e) { e.preventDefault(); scrollToResults(); });
  }
  var sentinel = $('[data-tm-sentinel]');
  if (sentinel && 'IntersectionObserver' in window) new IntersectionObserver(function (en) { if (en[0].isIntersecting) more(); }, { rootMargin: '800px 0px' }).observe(sentinel);

  /* ---------- boot ---------- */
  X.load('/collections/all').then(function (list) {
    items = list;
    var maxD = 0;
    items.forEach(function (it) { if (dollars(it) > maxD) maxD = dollars(it); });
    MAXP = Math.min(2000, Math.max(500, 100 * Math.ceil(maxD / 100)));
    var brands = {};
    items.forEach(function (it) { if (it.br) brands[it.br] = 1; });
    var st = $('[data-tm-stats]');
    if (st) st.innerHTML = '<b>' + items.length + '</b> products · <b>' + Object.keys(brands).length + '</b> brands · member prices on <b>every one</b>';
    if (full) {
      var u = new URLSearchParams(location.search);
      steps.forEach(function (s) {
        if (!s.opts) return;
        var v = u.get(s.key);
        if (v) state.sel[s.key] = v.split(',').filter(function (x) { return s.opts.some(function (o) { return o.v === x; }); });
      });
      if (u.get('min')) state.min = +u.get('min') || 0;
      if (u.get('max')) state.max = +u.get('max') || Infinity;
      if (u.get('q')) { state.q = u.get('q'); var qi = $('[data-tm-q]'); if (qi) qi.value = state.q; }
    }
    apply();
    if (full && location.search) setTimeout(scrollToResults, 300);
  }).catch(function () {
    $('[data-tm-res-title]').innerHTML = 'Sorry — the finder couldn\'t load. <a href="/collections/all">Browse all products</a>.';
  });
})();
